<template lang="html">
  <div id="root d-flex" style="overflow-y: scroll !important; height: 100vh;">
    <div id="nav" class="nav-container d-flex" :style="navStyle">
      <div class="nav-content d-flex">
        <!-- Logo Start -->
        <div class="logo position-relative">
          <a href="/">
            <div class="img"></div>
          </a>
        </div>

        <!-- User Menu Start -->
        <div class="user-container d-flex" style="display:none!important;" ref="menu">

          <a href="#"
             v-if="current_establishment != 'all'"
             class="d-flex user position-relative m-1 px-1 py-3"
             @click="openModelSelectEstablishment"
             style="background-color:#fff;">
            <div class="hotellogo"
                 :style="{'background-image': 'url('+settings.backendMediaUrl+current_establishment.logo+')'}"
                 style="background-size:cover;"
                 v-if="current_establishment.logo != undefined">
            </div>

            <div class="heading mb-0">{{ current_establishment.name }}</div>
            <span class="badge rounded-pill bg-warning me-1 position-absolute e-n3 t-n2 z-index-1"
                  data-bs-toggle="tooltip"
                  data-bs-placement="right"
                  title=""
                  data-bs-original-title="Demande d'information">
            {{ current_establishment.nb_infoneeded }}
          </span>
            <span class="badge rounded-pill bg-dark me-1 position-absolute e-n3 t-3 z-index-1"
                  data-bs-toggle="tooltip"
                  data-bs-placement="right"
                  title=""
                  data-bs-original-title="Réponse à valider">
            {{ current_establishment.nb_answerwriting }}
          </span>
            <span class="badge rounded-pill bg-secondary me-1 position-absolute e-n3 t-8 z-index-1"
                  data-bs-toggle="tooltip"
                  data-bs-placement="right"
                  title=""
                  data-bs-original-title="Signalement en cours">
            {{ current_establishment.nb_signaling }}
          </span>
          </a>

          <a href="#"
             v-else
             class="d-flex user position-relative m-1 px-2 py-2"
             @click="openModelSelectEstablishment"
             style="background-color:#fff;">
            <div class="hotellogo"
                 :style="{'background-image': 'url('+settings.backendMediaUrl+gathering.logo+')'}"
                 style="background-size:cover;background-position:center;"
                 v-if="gathering && gathering.logo != undefined">
            </div>

            <div class="heading mb-0 p-0" style="word-break: break-all;">Tous les établissements</div>
            <span class="badge rounded-pill bg-warning me-1 position-absolute e-n3 t-n2 z-index-1"
                  data-bs-toggle="tooltip"
                  data-bs-placement="right"
                  title=""
                  data-bs-original-title="Demande d'information">
            {{ all.nb_infoneeded }}
          </span>
            <span class="badge rounded-pill bg-dark me-1 position-absolute e-n3 t-3 z-index-1"
                  data-bs-toggle="tooltip"
                  data-bs-placement="right"
                  title=""
                  data-bs-original-title="Réponse à valider">
            {{ all.nb_answerwriting }}
          </span>
            <span class="badge rounded-pill bg-secondary me-1 position-absolute e-n3 t-8 z-index-1"
                  data-bs-toggle="tooltip"
                  data-bs-placement="right"
                  title=""
                  data-bs-original-title="Signalement en cours">
            {{ all.nb_signaling }}
          </span>
          </a>

        </div>
        <!-- User Menu End -->

        <!-- Menu Start -->
        <div class="menu-container flex-grow-1 mymenu">
          <ul id="menu" class="menu p-3 show ">
            <li class="mb-2">
              <a href="#"
                 id="click_gathering_review_list"
                 onclick="window.dispatchEvent(new Event('click_gathering_review_list'));">
                <i data-acorn-icon="home"
                   class="icon_"
                   data-acorn-size="40"
                   data-acorn-stroke-width="0.5"></i>
                <span class="label text-center">Liste des avis à traiter</span>
              </a>
            </li>
            <li class="mb-2">
              <a href="#"
                 id="click_gathering_show_report"
                 onclick="window.dispatchEvent(new Event('click_gathering_show_report'));">
                <i data-acorn-icon="chart-4"
                   class="icon_"
                   data-acorn-size="40"
                   data-acorn-stroke-width="0.5"></i>
                <span class="label">Rapports</span>
              </a>
            </li>
            <li class="mb-2">
              <a href="#"
                 id="click_gathering_stats"
                 onclick="window.dispatchEvent(new Event('click_gathering_stats'));">
                <i data-acorn-icon="file-chart"
                   class="icon_"
                   data-acorn-size="40"
                   data-acorn-stroke-width="0.5"></i>
                <span class="label">Statistiques</span>
              </a>
            </li>
            {{ activeHelpLink }}
            <li class="mb-2" v-for="link in otherLinks" :key="link.uid" :id="'helplink_' + link.uid">
              <a href="#"
                 :id="'link_' + link.uid"
                 :class="{ active: activeHelpLink && activeHelpLink.uid === link.uid }"
                 :onclick="`window.dispatchEvent(new Event('click_help_${link.uid}'))`"
              >
                <i data-acorn-icon="help"
                   class="icon_"
                   data-acorn-size="40"
                   data-acorn-stroke-width="0.5"></i>
                <span class="label text-center">{{ link.label }}</span>
              </a>
            </li>
<!--            <li class="mb-2" v-if="current_establishment && current_establishment !== 'all'">
              <a href="#"
                 id="click_gathering_settings"
                 onclick="window.dispatchEvent(new Event('click_gathering_settings'));">
                <i data-acorn-icon="gear"
                   class="icon_"
                   data-acorn-size="40"
                   data-acorn-stroke-width="0.5"></i>
                <span class="label">Paramètres</span>
              </a>
            </li>-->
            <li class="mb-2">
              <a href="#" onclick="window.dispatchEvent(new Event('click_gathering_logout'));">
                <i data-acorn-icon="logout"
                   class="icon_"
                   data-acorn-size="40"
                   data-acorn-stroke-width="0.5"></i>
                <span class="label">Déconnexion</span>
              </a>
            </li>
          </ul>
        </div>
        <!-- Menu End -->

        <!-- Mobile Buttons Start -->
        <div class="mobile-buttons-container">
          <!-- Menu Button Start -->
          <a href="#" id="mobileMenuButton" class="menu-button">
            <i data-acorn-icon="menu"></i>
          </a>
          <!-- Menu Button End -->
        </div>
        <!-- Mobile Buttons End -->
      </div>
      <div class="nav-shadow"></div>
    </div>

    <div class="mymodal" ref="selectHotelModel" style="height:100%;">
      <div class="modal-background"></div>
      <div class="card" style="height:100%;">
        <div class="card-content">

          <div class="is-pulled-right is-pointer"
               style="width:30px;"
               @click="closeModelSelectEstablishment">
            <i data-acorn-icon="close"
               data-acorn-size="30"
               data-acorn-stroke-width="1.5"></i>
          </div>
          <h5 class="modal-title">Choix de mon établissement</h5>
          <hr style="background-color:black;">
          <div class="" style="overflow-y:scroll;overflow-x:hidden;" :style="{'max-height':winHeight+'px'}">


            <div class="row g-0 sh-12 sh-sm-14" v-if="establishments.length > 1">
              <div class="col-auto h-100 position-relative">
                <div class="profile h-100 sw-9 sw-sm-12 sw-lg-15"
                     :style="{'background-image': 'url('+settings.backendMediaUrl+gathering.logo+')'}"
                     style="background-size:cover;background-position:center;"
                     v-if="gathering && gathering.logo != undefined">
                </div>
              </div>
              <div class="col p-0">
                <div class="card-body d-flex align-items-center justify-content-between h-100 py-3">
                  <div class="mb-0 h6">
                    <a @click="selectEstablishment('all')" class="body-link stretched-link">
                      <div class="clamp-line sh-3 lh-1-5" data-line="1">Tous les établissements</div>
                    </a>
                    <div class="card-text mb-2">    
                      <span class="badge rounded-pill bg-outline-warning mb-1">
                        {{ all.nb_infoneeded }} Demande{{ all.nb_infoneeded > 1 ? 's' : '' }}
                      </span>
                      <span class="badge rounded-pill bg-outline-dark mb-1">
                        {{ all.nb_answerwriting }} Validation{{ all.nb_answerwriting > 1 ? 's' : '' }}
                      </span>
                      <span class="badge rounded-pill bg-outline-secondary mb-1">
                        {{ all.nb_signaling }} Signalement{{ all.nb_signaling > 1 ? 's' : '' }}
                      </span>
                    </div>

                  </div>
                </div>
              </div>
            </div>

            <div class="card hover-scale-up mb-4" v-for="e in establishments">

              <div class="row g-0 sh-12 sh-sm-14">
                <div class="col-auto h-100 position-relative">
                  <div class="profile h-100 sw-9 sw-sm-12 sw-lg-15"
                       :style="{'background-image': 'url('+settings.backendMediaUrl+e.logo+')'}"
                       style="background-size:cover;"
                       v-if="e.logo != undefined">
                  </div>
                </div>
                <div class="col p-0">
                  <div class="card-body d-flex align-items-center justify-content-between h-100 py-3">
                    <div class="mb-0 h6" :title="e.name">
                      <a @click="selectEstablishment(e)" class="body-link stretched-link">
                        <div class="clamp-line sh-3 lh-1-5" data-line="1"
                             style="overflow:hidden;text-overflow: ellipsis;max-width:220px;">{{ e.name }}
                        </div>
                      </a>
                      <div class="card-text mb-2">
                      <span class="badge rounded-pill bg-outline-warning mb-1">
                        {{ e.nb_infoneeded }} Demande{{ e.nb_infoneeded > 1 ? 's' : '' }}
                      </span>
                        <span class="badge rounded-pill bg-outline-dark mb-1">
                        {{ e.nb_answerwriting }} Validation{{ e.nb_answerwriting > 1 ? 's' : '' }}
                      </span>
                        <span class="badge rounded-pill bg-outline-secondary mb-1">
                        {{ e.nb_signaling }} Signalement{{ e.nb_signaling > 1 ? 's' : '' }}
                      </span>
                      </div>

                    </div>
                    <div
                        class="sw-7 sh-6 d-flex justify-content-center align-items-center border border-dark rounded-xl">
                      <div class="cta-2">{{ e.stats_average_mark }}<small>/10</small></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <main class="ms-md-0 ms-lg-5">
      <div class="container">
        <!-- Title and Top Buttons Start -->
        <div class="page-title-container" v-if="showing == 'review_list'">
          <div class="row">
            <!-- Title Start -->
            <div class="col-12 col-md-8">

              <div class="alert alert-primary alert-dismissible fade show" role="alert" v-if="false">
                <strong>Enregistrement effectué !</strong>
                Nous avons notifié votre consultant de cette mise à jour.
                <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
              </div>

              <h1 class="display-4" id="title">
                Bonjour <span style="text-transform:capitalize;">{{ $store.state.profile.data.first_name }}</span>,
              </h1>
            </div>
            <div class="col-12 col-md-4  d-flex align-items-end justify-content-end">

              <button
                  type="button"
                  class="btn btn-outline-primary dropdown-toggle dropdown-toggle-split"
                  data-bs-offset="0,3"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  v-show="$store.state.profile.data.can_download_reviews == true"
              >
                <i data-acorn-icon="download" data-acorn-size="15" data-acorn-stroke-width="1.5"></i>
                <span class="me-2 ms-2">Exporter les avis</span>
              </button>
              <div class="dropdown-menu dropdown-menu-end p-3">
                <div class="input-daterange input-group d-flex flex-column" id="datePickerRange">
                  <label class="top-label mb-2">
                    <input ref="export_start"
                           type="text"
                           class="form-control datepicker"
                           name="start"/>
                    <span>Date début</span>
                  </label>
                  <label class="top-label mb-2">
                    <input ref="export_end"
                           type="text"
                           class="form-control datepicker"
                           name="end"/>
                    <span>Date fin</span>
                  </label>

                </div>
                <button class="btn btn-outline-primary w-100"
                        type="button"
                        @click="exportReviews()">
                  Exporter la sélection
                </button>

              </div>

            </div>
            <!-- Title End -->
          </div>
        </div>
        <!-- Title and Top Buttons End -->

        <!-- Stats Start -->
        <div class="row" v-if="showing == 'review_list'
                              && current_establishment != {} ">
          <div class="col-12 col-xl-4">
            <VotreConsultant v-if="current_establishment != 'all'"
                             :consultant="current_establishment.consultant"></VotreConsultant>
            <VotreConsultant v-if="current_establishment == 'all' && gathering && gathering.consultant"
                             :consultant="gathering.consultant"></VotreConsultant>
          </div>
          <div class="col-12 col-xl-8">
            <GatheringStats v-if="current_establishment != 'all'"
                            :establishment="current_establishment"></GatheringStats>
          </div>
        </div>
        <!-- Stats End -->

        <div class="row" v-if="showing == 'review_list'">
          <div class="col-12 mb-5">
            <div class="row">
              <div class="col-12 col-md-6">
                <h2 class="small-title" v-if="current_establishment == 'all'">
                  Il y a <b>{{ to_be_done }} avis</b> en cours de traitement</h2>
                <h2 class="small-title" v-else>
                  Vous avez <b>{{ to_be_done }} avis</b> à traiter</h2>
              </div>
              <div class="col-12 ">
                <div class="btn-group mb-1 float-left my-btn-group-review-list"
                     v-if="hasAccessToHistory()"
                     role="group"
                     aria-label="Basic example">
                  <button type="button" class="btn btn-primary btn-sm"
                          :class="{'active': filter == 'all'}"
                          @click="filter='all'">Tous
                  </button>
                  <button type="button" class="btn btn-primary btn-sm"
                          :class="{'active': filter == 'todo'}"
                          @click="filter='todo'">A traiter ({{ to_be_done }})
                  </button>
                  <button type="button" class="btn btn-primary btn-sm"
                          :class="{'active': filter == 'done'}"
                          @click="filter='done'">Traités ({{ done }})
                  </button>
                </div>
                <div class="btn-group mb-1 is-pulled-right my-btn-group-review-list"
                     role="group"
                     v-if="hasAccessToHistory()"
                     aria-label="Basic example">
                  <button type="button" class="btn btn-primary btn-sm"
                          :class="{'active': date_filter == 'one_week'}"
                          v-if="hasAccessToFilter('one_week') || hasAccessToFilter('one_month') || hasAccessToFilter('last_month')"
                          @click="date_filter='one_week'">une semaine
                  </button>
                  <button type="button" class="btn btn-primary btn-sm"
                          :class="{'active': date_filter == 'one_month'}"
                          v-if="hasAccessToFilter('one_month') || hasAccessToFilter('last_month')"
                          @click="date_filter='one_month'">un mois
                  </button>
                  <button type="button" class="btn btn-primary btn-sm"
                          :class="{'active': date_filter == 'last_month'}"
                          v-if="hasAccessToFilter('last_month')"
                          @click="date_filter='last_month'">le mois dernier
                  </button>
                </div>

              </div>
            </div>
            <div class="card mb-2 mt-2 bg-transparent no-shadow d-none d-lg-block">
              <div class="card-body pt-0 pb-0 sh-3">
                <div class="row g-0 h-100 align-content-center" style="padding-left:45px;">

                  <div class="col-6 col-lg-2 d-flex align-items-center
                            text-alternate text-medium text-muted text-small is-pointer"
                       style="padding-left:23px;"
                       @click="orderBy(['establishment', 'name'])">
                    ETABLISSEMENT&nbsp;
                    <i class="fa"
                       :class="{'fa-arrow-down': sortDirection == 'ASC',
                                'fa-arrow-up': sortDirection != 'ASC'}"
                       v-if="sortOrder.toString() == ['establishment', 'name'].toString()"></i>
                  </div>
                  <div class="col-6 col-lg-2 d-flex align-items-center
                            text-alternate text-medium text-muted text-small is-pointer "
                       @click="orderBy(['current_state', 'verbose_name'])">
                    STATUTS&nbsp;
                    <i class="fa"
                       :class="{'fa-arrow-down': sortDirection == 'ASC',
                                'fa-arrow-up': sortDirection != 'ASC'}"
                       v-if="sortOrder.toString() == ['current_state', 'verbose_name'].toString()"></i>
                  </div>
                  <div class="col-6 col-lg-1 d-flex align-items-center
                            text-alternate text-medium text-muted text-small"
                       @click="orderBy(['nb_message'])">
                    NOUVEAU<br>MESSAGE
                    <i class="fa"
                       :class="{'fa-arrow-down': sortDirection != 'ASC',
                                'fa-arrow-up': sortDirection == 'ASC'}"
                       v-if="sortOrder.toString() == ['nb_message'].toString()"></i>
                  </div>
                  <div class="col-6 col-lg-1 d-flex align-items-center
                            text-alternate text-medium text-muted text-small is-pointer"
                       @click="orderBy(['mark'])">
                    NOTE&nbsp;
                    <i class="fa"
                       :class="{'fa-arrow-down': sortDirection != 'ASC',
                                'fa-arrow-up': sortDirection == 'ASC'}"
                       v-if="sortOrder.toString() == ['mark'].toString()"></i>
                  </div>
                  <div class="col-6 col-lg-3 d-flex align-items-center
                            text-alternate text-medium text-muted text-small is-pointer"
                       @click="orderBy(['author'])">
                    AVIS&nbsp;
                    <i class="fa"
                       :class="{'fa-arrow-down': sortDirection == 'ASC',
                                'fa-arrow-up': sortDirection != 'ASC'}"
                       v-if="sortOrder.toString() == ['author'].toString()"></i>
                  </div>
                  <div class="col-6 col-lg-2 d-flex align-items-center text-alternate
                            text-medium text-muted text-small is-pointer"
                       style="text-transform: uppercase;"
                       @click="orderBy(['scraped_on'])">
                    DATE DE PUBLICATION&nbsp;
                    <i class="fa"
                       :class="{'fa-arrow-down': sortDirection != 'ASC',
                                'fa-arrow-up': sortDirection == 'ASC'}"
                       v-if="sortOrder.toString() == ['scraped_on'].toString()"></i>
                  </div>
                  <div class="col-12 col-lg-1 d-flex align-items-center mb-2 mb-lg-0
                            text-muted text-small is-pointer"
                       @click="orderBy(['platform', 'name'])">
                    PLATEFORME&nbsp;
                    <i class="fa"
                       :class="{'fa-arrow-down': sortDirection == 'ASC',
                                'fa-arrow-up': sortDirection != 'ASC'}"
                       v-if="sortOrder.toString() == ['platform', 'name'].toString()"></i>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="loading">
              <button class="button is-loading is-white"
                      style="font-size: 50px;background-color: transparent;width:100%;margin-top:50px;">
                Loading
              </button>
            </div>
            <div v-else>
              <EstablignmentGatheringLine
                  v-for="r in filteredReviews"
                  :key="r.uid"
                  :review="r"
                  :current_establishment="current_establishment"
                  v-on:selected-review="selectReview()"
              ></EstablignmentGatheringLine>
              <div v-if='filteredReviews.length == 0' class="alert alert-dark mt-5">
                Aucun avis à afficher
              </div>
            </div>
          </div>
        </div>

        <GatheringReviewDetail
            v-if="showing == 'review_detail'"
            :establishment="current_establishment"
            :review="current_review"
            :text_role="validation_roles ? validation_roles[current_establishment.uid] : null"
            v-on:goto_review_list="selectEstablishment(current_establishment)">
        </GatheringReviewDetail>

        <div v-if="showing == 'reports' && reports_access != null && current_establishment != 'all'">
          <div class="row">
            <div class="col-12 col-md-8">
              <h1 class="display-4"> Rapports</h1>
            </div>
            <div class="col-12 col-md-12" v-if="reports_access[current_establishment.uid]">
              <Reports :current-establishment="current_establishment"
                       :reports_access="reports_access"
                       :establishments="establishments"
              ></Reports>
            </div>
            <div v-else class="col-12 col-lg-7 mb-5">
              <div class="card sh-50 sh-sm-45 p-4">
                <img src="/img/chart/screenshot.png"
                     class="card-img h-100" alt="card image"
                     style="width:fit-content; margin-right:0px; margin-left: auto;opacity:0.2;">
                <div class="card-img-overlay d-flex flex-column justify-content-center bg-transparent">
                  <div>
                    <div class="cta-1 mb-3 text-black w-md-100 w-75">
                      Votre établissement n'a pas<br>souscrit à l'option rapports.
                    </div>
                    <div class="w-50 text-black mb-4">
                      Contactez-nous au
                      <a href="tel:0285521769">02 85 52 17 69</a><br>ou
                      <a href="mailto:hello@mhr.re">hello@mhr.re</a>
                      pour activer cette fonctionnalité.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="showing == 'reports' && current_establishment == 'all'"
             class="col-12 col-lg-7 mb-5">
          <div class="card sh-50 sh-sm-45 p-4">
            <img src="/img/chart/screenshot.png"
                 class="card-img h-100" alt="card image"
                 style="width:fit-content; margin-right:0px; margin-left: auto;opacity:0.2;">
            <div class="card-img-overlay d-flex flex-column justify-content-center bg-transparent">
              <div>
                <div class="cta-1 mb-3 text-black w-md-100 w-75">
                  Veuillez sélectionner un établissement pour afficher les rapports
                </div>
              </div>
            </div>
          </div>
        </div>


        <iframe
            v-if="showing == 'help'"
            :style="{height:iframeHeight+'px'}"
            class="cutom-iframe"
            :src="helpLink.href"></iframe>

        <iframe
            v-if="showing == 'stats' && statsLink.href != null && statsLink.href != '' "
            :style="{height:iframeHeight+'px'}"
            class="cutom-iframe"
            :src="statsLink.href"></iframe>

        <div
            v-if="showing == 'stats' && (statsLink.href == null || statsLink.href == '') && current_establishment != 'all'"
            class="col-12 col-lg-7 mb-5">
          <div class="card sh-50 sh-sm-45 p-4">
            <img src="/img/chart/screenshot.png"
                 class="card-img h-100" alt="card image"
                 style="width:fit-content; margin-right:0px; margin-left: auto;opacity:0.2;">
            <div class="card-img-overlay d-flex flex-column justify-content-center bg-transparent">
              <div>
                <div class="cta-1 mb-3 text-black w-md-100 w-75">
                  Votre établissement n'a pas<br>souscrit à l'option statistique.
                </div>
                <div class="w-50 text-black mb-4">
                  Contactez-nous au
                  <a href="tel:0285521769">02 85 52 17 69</a><br>ou
                  <a href="mailto:hello@mhr.re">hello@mhr.re</a>
                  pour activer cette fonctionnalité.
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="showing == 'stats' && current_establishment == 'all'"
             class="col-12 col-lg-7 mb-5">
          <div class="card sh-50 sh-sm-45 p-4">
            <img src="/img/chart/screenshot.png"
                 class="card-img h-100" alt="card image"
                 style="width:fit-content; margin-right:0px; margin-left: auto;opacity:0.2;">
            <div class="card-img-overlay d-flex flex-column justify-content-center bg-transparent">
              <div>
                <div class="cta-1 mb-3 text-black w-md-100 w-75">
                  Veuillez sélectionner un établissement pour afficher les statistiques
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="showing == 'establishment_settings' && current_establishment && current_establishment !== 'all'"
             class="col-12 mb-5">
          <h4 class="mb-3">Paramètres — {{ current_establishment.name }}</h4>
          <EstablishmentSettings :establishment="current_establishment" />
        </div>

        <Footer v-if="showing != 'help' && showing != 'stats'"></Footer>
      </div>
    </main>

  </div>
</template>

<<script>
import moment from 'moment'
import settings from '@/settings.coffee'
import REVIEW_DONE_SET from '@/gql/queries/reviewDoneSet.graphql'
import REVIEWS_TO_PROCESS from '@/gql/queries/reviewsToProcess.graphql'
import STAFF_ESTABLISHMENTS from '@/gql/queries/staffEstablishments.graphql'
import STAFF_STATS_LINK from '@/gql/queries/staffStatsLink.graphql'
import LINKS from '@/gql/queries/links.graphql'
import STAFF_ROLES from '@/gql/queries/staffRoles.graphql'
import GATHERING_FROM_STAFF from '@/gql/queries/gatheringFromStaff.graphql'
import { gqlQuery } from '@/gqlClient.js'
import EstablignmentGatheringLine from '@/components/EstablignmentGatheringLine'
import Reports from '@/components/Reports'
import Footer from '@/components/Footer'
import VotreConsultant from '@/components/VotreConsultant'
import GatheringStats from '@/components/GatheringStats'
import GatheringReviewDetail from '@/components/GatheringReviewDetail'
import EstablishmentSettings from '@/components/EstablishmentSettings'

export default {
  name: 'GatheringHome',
  components: {
    EstablignmentGatheringLine,
    Reports,
    Footer,
    VotreConsultant,
    GatheringStats,
    GatheringReviewDetail,
    EstablishmentSettings
  },
  data() {
    return {
      loading: true,
      navStyle: "display:none !important;",
      date_filter: "one_week",
      sortOrder: ["establishment", "name"],
      sortDirection: "ASC",
      filter: 'todo',
      gathering: null,
      can_export_reviews: false,
      iframeHeight: 500,
      winHeight: 500,
      export_start: null,
      export_end: null,
      establishments: [],
      otherLinks: [],
      helpLink: { label: null, href: null },
      statsLink: { label: null, href: null },
      staff: null,
      current_review: null,
      reviews: [],
      reports: [],
      reviews_count: 0,
      current_establishment: "",
      showing: null,
      reports_access: null,
      validation_roles: null,
      review_download: settings.backendUrl + "/admin/review/export/",
      logo_hotel: "",
      all: {
        nb_infoneeded: 0,
        nb_answerwriting: 0,
        nb_signaling: 0
      },
      activeHelpLink: null,
      fetchInProgress: false,
      fetchDone: false
    }
  },
  computed: {
    to_be_done() {
      let ret = 0
      for (let r of this.reviews) {
        if (!this.is_done(r)) ret++
      }
      return ret
    },
    done() {
      let ret = 0
      for (let r of this.reviews) {
        if (this.is_done(r)) {
          if (r.current_state && r.current_state.class_name !== "Classified") {
            ret++
          } else if (this.date_filter === "one_week") {
            if (moment(r.scraped_on).isAfter(moment().subtract(7, 'days'))) ret++
          } else if (this.date_filter === "one_month") {
            if (moment(r.scraped_on).isAfter(moment().subtract(1, 'months'))) ret++
          } else if (this.date_filter === "last_month") {
            ret++
          }
        }
      }
      return ret
    },
    settings() {
      return settings
    },
    filteredReviews() {
      let self = this
      let ret = []

      for (let r of this.reviews) {
        if (this.filter === "done") {
          if (this.is_done(r)) ret.push(r)
        } else if (this.filter === "todo") {
          if (!this.is_done(r)) ret.push(r)
        } else {
          ret.push(r)
        }
      }

      let ret2 = []
      for (let r of ret) {
        if (!r.current_state || r.current_state.class_name !== "Classified") {
          ret2.push(r)
        } else if (this.date_filter === "one_week") {
          if (moment(r.scraped_on).isAfter(moment().subtract(7, 'days'))) ret2.push(r)
        } else if (this.date_filter === "one_month") {
          if (moment(r.scraped_on).isAfter(moment().subtract(1, 'months'))) ret2.push(r)
        } else if (this.date_filter === "last_month") {
          if (moment(r.scraped_on).isAfter(moment().startOf('month').subtract(1, 'months'))) ret2.push(r)
        }
      }

      ret2.sort((a, b) => {
        let va = a
        let vb = b
        for (let col of self.sortOrder) {
          va = va[col]
          vb = vb[col]
        }
        if (self.sortDirection === "ASC") {
          if (va && typeof va.localeCompare === 'function') return va.localeCompare(vb)
          return va > vb ? 1 : va === vb ? 0 : -1
        } else {
          if (va && typeof va.localeCompare === 'function') return vb.localeCompare(va)
          return vb > va ? 1 : vb === va ? 0 : -1
        }
      })

      return ret2
    }
  },
  methods: {
    is_done(review) {
      if (!review.current_state) return true
      return !(
          review.current_state.class_name === 'AnswerTextValidation' ||
          review.current_state.class_name === 'WaitingForInformation' ||
          review.current_state.class_name === 'SignalingWriting' ||
          review.current_state.class_name === 'SignalingSent'
      )
    },
    hasAccessToHistory() {
      if (this.current_establishment === 'all') {
        let ret = false
        for (let key in this.$store.state.profile.data.can_view_history) {
          if (this.$store.state.profile.data.can_view_history[key] !== 'no_access') ret = true
        }
        return ret
      } else {
        return this.$store.state.profile.data.can_view_history[this.current_establishment.uid] &&
            this.$store.state.profile.data.can_view_history[this.current_establishment.uid] !== "no_access"
      }
    },
    hasAccessToFilter(filter_name) {
      let ret = false
      for (let key in this.$store.state.profile.data.can_view_history) {
        if (this.$store.state.profile.data.can_view_history[key] === filter_name) ret = true
      }
      return ret
    },
    orderBy(cols) {
      if (this.sortOrder.toString() === cols.toString()) {
        this.sortDirection = this.sortDirection === "ASC" ? "DESC" : "ASC"
      }
      this.sortOrder = cols
    },
    exportReviews() {
      this.$http.post(
          this.review_download,
          {
            start: this.$refs.export_start.value,
            end: this.$refs.export_end.value
          },
          { responseType: 'blob' }
      ).then((response) => {
        const fileURL = window.URL.createObjectURL(new Blob([response.body]))
        const fileLink = document.createElement('a')
        fileLink.href = fileURL
        fileLink.setAttribute('download', 'export.xlsx')
        document.body.appendChild(fileLink)
        fileLink.click()
      })
    },
    openModelSelectEstablishment() {
      this.$refs.selectHotelModel.classList.add('is-active')
    },
    closeModelSelectEstablishment() {
      if (this.$refs.selectHotelModel) {
        this.$refs.selectHotelModel.classList.remove('is-active')
      }
    },
    show_reports() {
      this.showing = 'reports'
    },
    show_settings() {
      this.showing = 'establishment_settings'
    },
    logout() {
      this.$http.get(settings.authApiUrlLogout).then(() => {
        location.reload()
      })
    },
    selectReview(evnt, arg) {
      this.showing = 'review_detail'
      this.current_review = evnt.detail
      for (let e of this.establishments) {
        if (e.uid === evnt.detail.establishment.uid) this.current_establishment = e
      }
      this.$router.push('/g/' + this.current_establishment.uid + '/' + evnt.detail.uid)
    },
    get_class(state_name) {
      return ['state-' + state_name.toLowerCase()]
    },
    async selectEstablishment(establishment, review_uid) {
      this.loading = true
      this.closeModelSelectEstablishment()
      this.showing = 'review_list'

      if (establishment === 'all') {
        this.current_establishment = "all"
        this.$router.push('/g/all')
        let r_done = await gqlQuery(REVIEW_DONE_SET, {})
        let r2 = await gqlQuery(REVIEWS_TO_PROCESS, {})

        if (r2.ok) {
          this.reviews = r2.body.data.reviews_to_process
          for (let r of r_done.body.data.review_done_set) this.reviews.push(r)

          this.all.nb_infoneeded = 0
          this.all.nb_answerwriting = 0
          this.all.nb_signaling = 0

          for (let r of this.reviews) {
            if (!r.current_state) continue
            if (["InformationNeeded", "WaitingForInformation"].includes(r.current_state.class_name)) {
              this.all.nb_infoneeded++
            }
            if (r.current_state.class_name === "AnswerTextValidation") this.all.nb_answerwriting++
            if (["SignalingWriting", "SignalingSent"].includes(r.current_state.class_name)) {
              this.all.nb_signaling++
            }
          }
        }
      } else {
        this.current_establishment = establishment
        let r = await gqlQuery(STAFF_ESTABLISHMENTS, { staff_uid: this.$store.state.profile.data.uid })
        if (r.ok) {
          this.establishments = r.body.data.get_staff_establishments
          for (let e of this.establishments) {
            if (e.uid === establishment.uid) this.current_establishment = e
          }
        }

        let rStats = await gqlQuery(STAFF_STATS_LINK, {
          profile_uid: this.$store.state.profile.data.uid,
          establishment_uid: this.current_establishment.uid
        })
        if (rStats.ok) this.statsLink = { href: rStats.body.data.staff_statslink }

        let r_done = await gqlQuery(REVIEW_DONE_SET, { establishment_uid: establishment.uid })
        let r2 = await gqlQuery(REVIEWS_TO_PROCESS, { establishment_uid: establishment.uid })
        if (r2.ok) {
          this.reviews = r2.body.data.reviews_to_process
          for (let r of r_done.body.data.review_done_set) this.reviews.push(r)

          if (review_uid) {
            for (let r of this.reviews) {
              if (r.uid === review_uid) {
                this.selectReview({ detail: r })
                this.$router.push('/g/' + establishment.uid + '/' + review_uid)
              }
            }
          } else {
            this.$router.push('/g/' + establishment.uid)
          }
        }
      }
      this.loading = false
    },
    resetActiveLinks() {
      for (let link of this.otherLinks) {
        let el = document.getElementById('link_' + link.uid)
        if (el) el.classList.remove('active')
      }
      let elStats = document.getElementById('click_gathering_stats')
      if (elStats) elStats.classList.remove('active')

      let elList = document.getElementById('click_gathering_review_list')
      if (elList) elList.classList.remove('active')

      let elReport = document.getElementById('click_gathering_show_report')
      if (elReport) elReport.classList.remove('active')

      let elSettings = document.getElementById('click_gathering_settings')
      if (elSettings) elSettings.classList.remove('active')
    },
    handleHelpLinkClick(link) {
      this.resetActiveLinks()
      for (let l of this.otherLinks) {
        if (link.uid === l.uid) {
          let el = document.getElementById('link_' + link.uid)
          if (el) el.classList.add('active')
        }
      }
      this.activeHelpLink = link
      this.helpLink = link
      this.showing = 'help'
    },
    initializeCustomEvents() {
      this.otherLinks.forEach((link) => {
        window.addEventListener(`click_help_${link.uid}`, () => {
          this.handleHelpLinkClick(link)
        })
      })
    },
    async fetch_data() {
      // ✅ Empêcher un double appel simultané
      if (this.fetchInProgress) {
        console.log("⏳ fetch_data déjà en cours, on ignore l'appel")
        return
      }

      // ✅ Empêcher de relancer si déjà exécuté une fois
      if (this.fetchDone) {
        console.log("✅ fetch_data déjà exécuté, on réutilise les données")
        return
      }

      this.fetchInProgress = true

      try {
        const uid = this.$store.state.profile.data.uid

        const [rLinks, rRoles, rGather, rEstabs] = await Promise.all([
          gqlQuery(LINKS, {}),
          gqlQuery(STAFF_ROLES, { staff_uid: uid }),
          gqlQuery(GATHERING_FROM_STAFF, { staff_uid: uid }),
          gqlQuery(STAFF_ESTABLISHMENTS, { staff_uid: uid })
        ])

        if (rLinks.ok) {
          this.otherLinks = rLinks.body.data.link_set
        }

        if (rRoles.ok) {
          this.reports_access = {}
          this.validation_roles = {}
          for (let role of rRoles.body.data.get_staff_roles) {
            this.reports_access[role.establishment.uid] = role.report_access
            this.validation_roles[role.establishment.uid] = role.text_role
          }
        }

        if (rGather.ok) {
          this.gathering = rGather.body.data.get_gathering_form_staff
        }

        if (rEstabs.ok) {
          this.establishments = rEstabs.body.data.get_staff_establishments
          // ⚡ garder ta logique d’init d’établissement
          if (this.$route.params.establishment_uid) {
            let selected = false
            if (this.$route.params.establishment_uid === 'all') {
              this.selectEstablishment('all')
            } else {
              for (let e of this.establishments) {
                if (e.uid === this.$route.params.establishment_uid) {
                  this.selectEstablishment(e, String(this.$route.params.review_uid))
                  selected = true
                }
              }
              if (!selected) this.selectEstablishment(this.establishments[0])
            }
          } else {
            if (this.establishments.length > 1) {
              this.selectEstablishment('all')
            } else {
              this.selectEstablishment(this.establishments[0])
            }
          }
        }

        if (this.$refs.menu) {
          this.$refs.menu.removeAttribute("style")
        }

        // ✅ Marquer comme fini
        this.fetchDone = true
      } catch (err) {
        console.error("Erreur dans fetch_data:", err)
      } finally {
        this.fetchInProgress = false
      }
    }

  },
  created() {
    this.$djangows['onmodelsignals']({ modelName: "email", appLabel: "core" }, (event) => { })
  },
  watch: {
    $route(to, from) {
      const regex = /^\/g\/((?:\w|-)+)$/g
      const m = regex.exec(to.path)
      if (m) {
        if (m[1] === "all" && m[1] !== this.current_establishment.uid) {
          this.selectEstablishment('all')
        } else {
          for (let e of this.establishments) {
            if (e.uid === m[1]) this.selectEstablishment(e)
          }
        }
      }
    },
    otherLinks: {
      handler(newVal, oldVal) {},
      deep: true
    }
  },
  async mounted() {
    let originalMenu = document.getElementById('menu')
    if (originalMenu) originalMenu.id = 'menu_temp'
    await this.fetch_data()
    setTimeout(() => {
      let tempMenu = document.getElementById('menu_temp')
      if (tempMenu) {
        tempMenu.id = 'menu'
        this.initializeCustomEvents()
      }
    }, 200)

    window.addEventListener('resize', () => {
      this.iframeHeight = $(document).height() - 40
      this.winHeight = $(document).height() - 120
    })

    setTimeout(() => { this.navStyle = "" }, 500)
    this.iframeHeight = $(document).height() - 40
    this.winHeight = $(document).height() - 120

    setTimeout(() => {
      new AcornIcons().replace()
      let scripts = new Scripts()
      setTimeout(() => {
        $('.datepicker').datepicker({
          autoclose: true,
          format: "dd/mm/yyyy",
          weekStart: 1,
          language: 'fr'
        })
      }, 2000)
    }, 100)

    window.addEventListener('click_gathering_show_report', () => {
      this.show_reports()
      this.resetActiveLinks()
      document.getElementById('click_gathering_show_report').classList.add('active')
      window.gatheringNav._hideMobileMenu()
    }, false)

    window.addEventListener('click_gathering_review_list', () => {
      this.resetActiveLinks()
      document.getElementById('click_gathering_review_list').classList.add('active')
      let etab = this.establishments[0]
      if (this.current_establishment) etab = this.current_establishment
      this.selectEstablishment(etab)
      window.gatheringNav._hideMobileMenu()
    }, false)

    window.addEventListener('click_gathering_logout', () => { this.logout() }, false)
    window.addEventListener('click_gathering_settings', () => {
      this.resetActiveLinks()
      const el = document.getElementById('click_gathering_settings')
      if (el) el.classList.add('active')
      this.show_settings()
      window.gatheringNav._hideMobileMenu()
    }, false)
    window.addEventListener('click_gathering_review_detail', (arg) => { this.selectReview(arg) }, false)
    window.addEventListener('click_gathering_stats', () => {
      this.resetActiveLinks()
      document.getElementById('click_gathering_stats').classList.add('active')
      this.showing = "stats"
      window.gatheringNav._hideMobileMenu()
    }, false)
  }
}
</script>



<style lang="css" scoped>
/*
@import '../assets/css/vendor/bootstrap.min.css';
@import '../assets/css/styles.css';
@import '../assets/css/main.css';
*/

.heading {
}

.container {
  width: unset;
}

li > a {
  box-sizing: border-box;
}

.label {
  color: white;
  font-weight: 400;
}

.modal {
  z-index: 1060;
}

.mymodal.is-active {
  left: 0;
}

.mymodal {
  z-index: 1050;
  position: fixed;
  left: -500px;
  top: 0;
  min-height: 100%;
  width: 500px;
  transition: left .15s linear;
  display: grid;
}

.mymodal > .card {
  z-index: 1050;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  height: 100%;
  background: rgb(249, 249, 249);
}

.mymodal > .modal-background {
  position: fixed;
  width: 0%;
  height: 100%;
  z-index: 1040;
  background-color: rgba(128, 128, 128, 0.7);
  opacity: 0;
  transition: opacity .15s linear;
}

.mymodal.is-active > .modal-background {
  width: 100%;
  opacity: 1;
}

.is-pointer {
  cursor: pointer;
}

.hotellogo {
  height: 50px;
  width: 50px;
  margin: 0 auto;
}

progress {
  height: 3px;
}

.cutom-iframe {
  width: calc(100% + 100px);
  margin: -40px -50px -80px -50px;
}

.mymenu {
  overflow-y: auto;
  overflow-x: hidden;
  max-height: calc(100% - 0px);
}

@media (max-width: 991px) {
  .my-btn-group-review-list {
    width: 100%;
  }
}

@media (min-width: 768px) {
  main {
    margin-left: 0;
  }
}

@media (min-width: 992px) {
  main {
    margin-left: 15rem !important;
  }
}
</style>
  